import {useState, useEffect,useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectServicioSoftland = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps,
    isMulti
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const [options, setOptions] = useState([
        {
            value: 'PLAN S',
            label: 'PLAN S'
        },
        {
            value: 'PLAN M',
            label: 'PLAN M'
        },
        {
            value: 'PLAN L',
            label: 'PLAN L'
        },
        {
            value: 'PLAN XL',
            label: 'PLAN XL'
        },
        {
            value: 'PLAN PLATA',
            label: 'PLAN PLATA'
        },
        {
            value: 'PLAN ORO',
            label: 'PLAN ORO'
        },
        {
            value: 'PLAN PLATINUM',
            label: 'PLAN PLATINUM'
        },
        {
            value: 'PLAN CORPORTATIVO',
            label: 'PLAN CORPORTATIVO'
        },
        {
            value: 'PLAN GOBIERNO',
            label: 'PLAN GOBIERNO'
        },
        {
            value: 'PLAN 200 Mb',
            label: 'PLAN 200 Mb'
        },
        {
            value: 'PLAN 400 Mb',
            label: 'PLAN 400 Mb'
        },
        {
            value: 'PLAN 700 Mb',
            label: 'PLAN 700 Mb'
        },
        {
            value: 'PLAN 1000 Mb',
            label: 'PLAN 1000 Mb'
        },
        {
            value: 'PLAN BASIC 100 Mb',
            label: 'PLAN BASIC 100 Mb'
        },
        {
            value: 'PLAN PLUS 300 Mb',
            label: 'PLAN PLUS 300 Mb'
        },
        {
            value: 'PLAN LIFE 600 Mb',
            label: 'PLAN LIFE 600 Mb'
        },
        {
            value: 'PLAN FO 600/300 MB',
            label: 'PLAN FO 600/300 Mb'
        },
        {
            value: 'IPTV',
            label: 'IPTV'
        },
        {
            value: 'CAMBIO DE PLAN',
            label: 'CAMBIO DE PLAN'
        },
        {
            value: 'CAMBIO DE DOMICILIO',
            label: 'CAMBIO DE DOMICILIO'
        },
        {
            value: 'OTROS',
            label: 'OTROS'
        }
    ]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [options,value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectServicioSoftland.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectServicioSoftland;